<template>
  <div class="bidlist">
    <!-- <SmsCode /> -->
    <!-- <SuccessTransfer /> -->

    <v-data-table
      :mobile-breakpoint="100"
      class="bidlist-table"
      :headers="headers"
      :items="reports"
      item-key="id"
      :server-items-length="total"
      :options.sync="options"
      :footer-props="footerProps"
      :no-data-text="noDataText"
    >
      <!--    <template #[`item.dadd`]="{ value }">
        <span>
          <span>{{ new Date(value).toLocaleDateString() }}</span
          ><br />
          <span class="font font--label-light font--color_light">{{
            new Date(value).toLocaleTimeString()
          }}</span>
        </span>
      </template>

      <template #[`item.act`]="{ value }">
        <span>
          <span>{{ value }}</span>
        </span>
      </template>

      <template #[`item.deal`]="{ value }">
        <span>
          <span>{{ value }}</span>
        </span>
      </template>

      <template #[`item.sum`]="{ value }">
        <span>{{ makeRub(value) }}</span>
      </template>

      <template #[`item.id`]="{ value }">
        <v-btn :href="item.url" @click.prevent="downloadItem(item)" download
          ><v-icon>mdi-download</v-icon></v-btn
        >
      </template> -->
    </v-data-table>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
// import SmsCode from "@/components/payment/SmsCode.vue";
// import SuccessTransfer from "@/components/payment/SuccessTransfer.vue";
import { mapActions, mapMutations, mapState } from "vuex";

import DateFilter from "@/components/common/DateFilter";

export default {
  //   props: {
  //     items: Array,
  //   },

  components: {
    // SmsCode,
    // SuccessTransfer,
  },

  data() {
    return {
      downloadItem: true,
      footerProps: {
        itemsPerPageText: "Актов и отчётов на странице:",
        itemsPerPageAllText: "Все",
        pageText: "{0}-{1} из {2}",
        itemsPerPageOptions: [5, 10, 15],
      },
      noDataText: "Нет данных",

      headers: [
        {
          text: "№ Акта",
          value: "num",
          sortable: false,
        },
        {
          text: "Дата",
          value: "dadd",
          sortable: false,
        },
        {
          text: "Акт",
          value: "name",
          sortable: false,
        },
        { text: "Сделка", value: "deal", sortable: false },
        { text: "Сумма", value: "sum", sortable: false },
        { value: "id", sortable: false },
      ],
    };
  },

  computed: {
    ...mapState({
      reports: (state) => state.reports.reports,
      //   total: (state) => state.bid.total,
    }),
    total() {
      return this.$store.state.reports.reports.length;
    },

    options: {
      get() {
        return {
          page: this.$store.state.reports.page,
          itemsPerPage: this.$store.state.reports.pageSize,
        };
      },
      set({ page, itemsPerPage }) {
        this.setPage(page);
        this.setPageSize(itemsPerPage);
      },
    },
  },

  watch: {
    options: {
      handler() {
        this.getBids();
      },
      deep: true,
    },
  },

  methods: {
    ...mapMutations("reports", ["setPage", "setPageSize"]),
    // ...mapActions("reports", ["getBids"]),
  },
  makeRub(value) {
    return makeCurrency(Number(value).toLocaleString());
  },
};
</script>

<style lang="scss">
.theme--light.v-data-table.bidlist-table > .v-data-table__wrapper > table > thead > tr > th {
  color: #777c87;
}

.v-data-table.bidlist-table > .v-data-table__wrapper > table > thead > tr > th {
  text-transform: uppercase;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.1em;
  font-weight: 400;
  height: auto;
  padding: 12px 16px;
}

.v-data-table.bidlist-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 16px;
}

.v-data-table-header {
  background-color: #f5f5f6;
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(100%, 0);
}
.summ {
  background-color: #f5f5f6;
  justify-content: center;
  border-radius: 4px;
}
</style>
